module.exports = __webpack_public_path__ + "product-pure-powder-capsule-main-thumb-03.jpg?c6f40e1be679dd6522b5e6b8c4fe9c9b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-main-thumb-03.jpg
// module id = 82
// module chunks = 0